import React, { useEffect, useState } from "react";

import SimpleCard from '../components/SimpleCard';
import CryptoCard from '../components/CryptoCard';

import Word from '../assets/elements/Animations/estrellas2.json';
import Security from '../assets/elements/Animations/Escudo.json';
import Servers from '../assets/elements/Animations/contenedores.json';
import Triangle from '../assets/elements/Animations/piramide.json';
import Lines from '../assets/elements/SVG ASSETS/YellowLines.svg';
import Circle from '../assets/elements/SVG ASSETS/Circles.svg';
import Arrow from '../assets/elements/SVG ASSETS/chevron_down.svg';
import Lottie from "lottie-react";

import Contact from '../components/Contact';
import NodeOperators from '../components/NodeOperators';
import { BlockchainService } from '../services/blockchainService';
import { snapshotUrlFor, useSnapshotNetworks } from '../services/snapshotNetworks';
import { prefersReducedMotion } from '../utility/motion';
import type { HygraphBlockchain } from '../types';

function Dashboard() {

  const [blockchains, setBlockchains] = useState<HygraphBlockchain[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const snapshotNetworks = useSnapshotNetworks();

  useEffect(() => {
    loadBlockchains()
  }, []);

  async function loadBlockchains() {
    try {
      setLoading(true);
      setError(null);
      const data = await BlockchainService.getAllBlockchains();
      
      // Sort all blockchains by importance weight (sortOrder) only
      // Higher sortOrder = higher importance = display higher
      const sortedBlockchains = [...data].sort((a, b) => {
        return b.sortOrder - a.sortOrder;
      });
      
      setBlockchains(sortedBlockchains);
    } catch (err) {
      console.error('Failed to load blockchains from Hygraph:', err);
      setError('Failed to load blockchain data');
    } finally {
      setLoading(false);
    }
  }


  return (
    <div className="App">
      <div className="container pt-20">
        <h1 className="titles">EARN
          <br />
          <div className="titles-yellow">STAKING REWARDS</div>
          <br />
          ON YOUR CRYPTO ASSETS
          <br />
          WITH CONFIDENCE
        </h1>
        <p className="py-8 sub-title">Our professional staking services support the future
          of decentralised ﬁnance, gaming and trade</p>
        <div className='hidden lg:flex justify-center'>
          <Lottie
                    loop={!prefersReducedMotion}
                    autoplay={true}
                    animationData={Word}
                    rendererSettings={{
                        preserveAspectRatio: "xMidYMid slice"
                    }}
                />
        </div>
        <a href='#cryptos' aria-label='Skip to our networks'><img className='arrow-home' src={Arrow} alt=''/></a>
        <div id='Benefits' className='flex flex-col lg:flex-row lg:px-10 lg:py-11'>
          <SimpleCard title="Security focused." text="We provide high quality, secure, and professionally managed infrastructure so that you can be conﬁdent in your staking rewards, day after day." src={Security} />
          <SimpleCard title="Only the best networks." text="We only run validator nodes on networks that we believe to be the best candidates for successful blockchains and products. We stake our own assets as proof." src={Triangle} />
          <SimpleCard title="Slash protected." text="You can be conﬁdent in your investment with our 100% soft-slash protection. We will refund any funds lost to a downtime slash." src={Servers} />
        </div>
      </div>
      <div className='flex flex-col lg:flex-row lg:py-11'>
        <img src={Lines} alt='' />
        <div className='flex flex-col pt-10 lg:px-10 lg:mx-5'>
          <div className='flex flex-col xl:flex-row px-5'>
            <h2 className='flex justify-start p-sub-yellow '>Our Supported Networks</h2> <p className='flex justify-start p-sub-grey hidden-component'>Stake with the best</p>
          </div>
          <div className='flex flex-col lg:flex-row px-5 py-5'>
            <p className='text-left p1-gray our-professional'>Stake your tokens on any of our supported networks. By staking your tokens, you help to secure the network from bad actors and receive staking rewards.</p>
          </div>
        </div>
      </div>
      <div className='mt-10 md:mt-0'>
        <div id='cryptos' className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <p className='vertical-text text-left mb-10'>
            {"OUR"}
            <br className='hidden-component' />
            NETWORKS</p>
          <div className='col-span-2 lg:grid grid-cols-3 flex-1 mt-10 md:mt-0 lg:pr-10'>
            {loading && <div className="col-span-3 text-center">Loading blockchain data...</div>}
            {error && <div className="col-span-3 text-center text-red-500">Failed to load blockchain data</div>}
            {!loading && !error && blockchains.map(item => (
              <CryptoCard 
                key={item.id} 
                name={item.blockchainName} 
                description={item.descriptionShort} 
                img={item.icon?.url || ''} 
                buttonStatus={item.buttonStatus} 
                link={item.stakeNowButtonLink}
                snapshotsUrl={snapshotUrlFor(snapshotNetworks, item.blockchainName)}
              />
            ))}
          </div>
        </div>
      </div>
      <NodeOperators networks={snapshotNetworks} />
        <div className='hidden lg:block container-bg2 items-center'>
          <img src={Circle} alt='' />
          <div className='text-over flex flex-row items-center'>{"START STAKING"} <p className='pl-2 yellow'>{" NOW"}</p></div>
        </div>
      <Contact/>
    </div>
  );
}


export default Dashboard;
